import ClientSSOMetadata from "./ClientSSOMetadata";

class ClientSSO {
    constructor(
      public client_id: string,
      public client_secret: string,
      public client_metadata: ClientSSOMetadata,
      public id?: number | undefined,
    ) {}
  }
  
  export default ClientSSO;
  